import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Livraisons from './pages/Livraisons';
import Saisies from './pages/Saisies';
import Clients from './pages/Clients';
import NouvelleSaisie from './pages/NouvelleSaisie';
import ModifierSaisie from './pages/ModifierSaisie';
import NouvelleLivraison from './pages/NouvelleLivraison';
import NouveauClient from './pages/NouveauClient';
import DetailClient from './pages/DetailClient';
import ModifierClient from './pages/ModifierClient';
import Drydocs from './pages/Drydocs';
import NouveauDrydoc from './pages/NouveauDrydoc';
import ModifierDrydoc from './pages/ModifierDrydoc';
import Fournisseurs from './pages/Fournisseurs';
import Rapports from './pages/Rapports';
import Utilisateurs from './pages/Utilisateurs';
import Profil from './pages/Profil';
import Parametres from './pages/Parametres';
import { AuthProvider } from './contexts/AuthContext';
import ClientLivraisons from './pages/ClientLivraisons';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Route client indépendante sans Sidebar */}
          <Route path="/client" element={<ClientLivraisons />} />
          
          {/* Routes desktop avec Sidebar */}
          <Route path="/*" element={
            <div className="flex h-screen bg-port-gray-50">
              <Sidebar />
              <div className="flex-1 flex flex-col overflow-hidden">
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-port-gray-50">
                  <div className="container mx-auto px-6 py-8">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/livraisons" element={<Livraisons />} />
                      <Route path="/saisies" element={<Saisies />} />
                      <Route path="/nouvelle-livraison" element={<NouvelleLivraison />} />
                      <Route path="/nouvelle-saisie" element={<NouvelleSaisie />} />
                      <Route path="/modifier-saisie/:id" element={<ModifierSaisie />} />
                      <Route path="/clients" element={<Clients />} />
                      <Route path="/nouveau-client" element={<NouveauClient />} />
                      <Route path="/detail-client/:id" element={<DetailClient />} />
                      <Route path="/modifier-client/:id" element={<ModifierClient />} />
                      <Route path="/drydocs" element={<Drydocs />} />
                      <Route path="/nouveau-drydoc" element={<NouveauDrydoc />} />
                      <Route path="/detail-drydoc/:id" element={<DetailClient />} />
                      <Route path="/modifier-drydoc/:id" element={<ModifierDrydoc />} />
                      <Route path="/fournisseurs" element={<Fournisseurs />} />
                      <Route path="/rapports" element={<Rapports />} />
                      <Route path="/utilisateurs" element={<Utilisateurs />} />
                      <Route path="/profil" element={<Profil />} />
                      <Route path="/parametres" element={<Parametres />} />
                    </Routes>
                  </div>
                </main>
              </div>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 